import axios from "../../../axios";

export const getProcesses = async (payload) => {  
  let data
  try {        
    if(payload){    
      data  = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot?limit=${payload.limit}&offset=${payload.offSet}`);
    }else{
      data  = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot`);
    }    
    return data.data
  } catch (e) {
    console.log("error while gettings processes", e)
  }
};
